import { render } from "./DockSeparator.vue?vue&type=template&id=5be0e9a8"
import script from "./DockSeparator.vue?vue&type=script&lang=js"
export * from "./DockSeparator.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/service/service-cp-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__